import { FloatingPresenceParam } from './floating-presence-param-models';

export class FloatingPresence {
    subdomain: string;
    country: string;
    websiteId: number;
    params: Record<string, FloatingPresenceParam>;
}
